import { apiClient } from '@/shared/api/client';
import type {
  Experience,
  CreateExperienceRequest,
  UpdateExperienceRequest,
  UpdateExperienceStatusRequest,
  ListExperiencesParams,
} from '../types/experience.types';
import type { ApiResponse } from '@/shared/types/api.types';

export const experienceService = {
  async listExperiences(params: ListExperiencesParams): Promise<Experience[]> {
    const endpoint = `/candidates/${params.candidateId}/experiences`;
    const response = await apiClient<ApiResponse<Experience[]>>(endpoint, { method: 'GET' });
    return response.data;
  },

  async getExperienceById(candidateId: string, experienceId: string): Promise<Experience> {
    const response = await apiClient<ApiResponse<Experience>>(
      `/candidates/${candidateId}/experiences/${experienceId}`,
      { method: 'GET' }
    );
    return response.data;
  },

  async createExperience(
    candidateId: string,
    request: CreateExperienceRequest
  ): Promise<Experience> {
    const response = await apiClient<ApiResponse<Experience>>(
      `/candidates/${candidateId}/experiences`,
      {
        method: 'POST',
        body: request,
      }
    );
    return response.data;
  },

  async updateExperience(
    candidateId: string,
    experienceId: string,
    request: UpdateExperienceRequest
  ): Promise<Experience> {
    const response = await apiClient<ApiResponse<Experience>>(
      `/candidates/${candidateId}/experiences/${experienceId}`,
      {
        method: 'PUT',
        body: request,
      }
    );
    return response.data;
  },

  async deleteExperience(candidateId: string, experienceId: string): Promise<Experience> {
    const response = await apiClient<ApiResponse<Experience>>(
      `/candidates/${candidateId}/experiences/${experienceId}`,
      { method: 'DELETE' }
    );
    return response.data;
  },

  async updateExperienceStatus(
    candidateId: string,
    experienceId: string,
    request: UpdateExperienceStatusRequest
  ): Promise<Experience> {
    const response = await apiClient<ApiResponse<Experience>>(
      `/candidates/${candidateId}/experiences/${experienceId}/status`,
      {
        method: 'PATCH',
        body: request,
      }
    );
    return response.data;
  },
};
